export interface IPropsVideo {
	videoTitle: string;
	videoId: string;
	autoplay: boolean;
	hash?: string;
}

export const AVAILABLE_VIDEOS: IPropsVideo[] = [
	{
		autoplay: true,
		videoTitle: 'A new title',
		videoId: '1084690378',
		hash: 'f1e38d7fdf'
	}
];
